import { formatRatingScore, IconStar } from '@madpaws/design-system';
import React from 'react';

import { DEFAULT_SERVICE_TITLE, SERVICE_TYPE_BY_NAME_MAPPING } from '~/common/constants/search';
import { Card } from '~/components/pages/SearchResults/Card/Card';

import styles from './RatingWidget.module.css';

import type { AggregateRating } from '~/common/types/search';

type Props = {
  aggregateRating?: AggregateRating;
  rating?: number;
  reviews?: number;
  service?: string;
  serviceSlug?: string;
};

export const RatingWidget = ({
  aggregateRating,
  rating,
  reviews,
  service,
  serviceSlug,
}: Props): React.ReactElement | null => {
  if (aggregateRating && serviceSlug) {
    const { ratingValue, ratingCount, ownersCount } = aggregateRating;

    if (!ratingValue || !ownersCount) {
      return null;
    }

    const serviceTypeTitle =
      SERVICE_TYPE_BY_NAME_MAPPING[serviceSlug]?.serviceTitle || DEFAULT_SERVICE_TITLE;

    return (
      <Card className={styles.root}>
        <div className={styles.ratingScore}>
          <IconStar size="large" />
          <strong className={styles.ratingValue}>{formatRatingScore(ratingValue)}</strong>
        </div>
        <p className={styles.serviceDetails}>Average rating of {serviceTypeTitle}</p>
        <div className={styles.verticalDivider} />
        <div className={styles.basedOn}>based on</div>
        <p className={styles.totalReviews}>
          {ratingCount} reviews of {ownersCount} Pet Owners
        </p>
      </Card>
    );
  }

  return (
    <Card className={styles.root}>
      <div className={styles.ratingScore}>
        <IconStar size="large" />
        {rating && <strong className={styles.ratingValue}>{formatRatingScore(rating)}</strong>}
      </div>
      <p className={styles.serviceDetails}>Average rating of {service}</p>
      <div className={styles.verticalDivider} />
      <div className={styles.basedOn}>based on</div>
      <p className={styles.totalReviews}>
        {reviews?.toLocaleString('en')} of pet sitters on Mad Paws
      </p>
    </Card>
  );
};
